// extracted by mini-css-extract-plugin
module.exports = {"title":"title---GUP0","subContent":"subContent--Wj3Gx"};